export const normalizeLocalityToCityId = locality =>
  locality
    ? locality
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/\s/g, '_')
    : '';

// Locate the typed term inside a suggestion's main_text or secondary_text so
// the dropdown can highlight the actual match. Used for providers whose API
// doesn't return matched_substrings (Mapbox suggest, MapTiler geocoding) or
// where the match may sit deep in the place name (fuzzy/contextual matches).
// Both sides are stripped of diacritics before comparison so typing "vallecas"
// still highlights "Vallecás". Returns length: 0 when the term isn't found, so
// the renderer paints nothing rather than mislead with a hardcoded highlight.
const stripDiacritics = s =>
  s.normalize('NFD').replace(/\p{Diacritic}/gu, '');

export const findMatchedSubstring = (text, value) => {
  if (!text || !value) return { offset: 0, length: 0 };
  const offset = stripDiacritics(text)
    .toLowerCase()
    .indexOf(stripDiacritics(value).toLowerCase());
  return offset >= 0
    ? { offset, length: value.length }
    : { offset: 0, length: 0 };
};
